/**
 *
 * Phone Number Field
 *
 */

import React from "react"
import PropTypes from "prop-types"
//import PhoneInput from 'react-phone-number-input'
import { Label, FormGroup } from "reactstrap"

import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"

function PhoneNumberField(props) {
  const {
    label,
    name,
    value,
    placeholder,
    onChange,
    required,
    disabled,
    prefix,
    onInputChange,
  } = props

  return (
    <React.Fragment>
      <FormGroup className="no-margin">
        <Label htmlFor={name}>
          {label} {required ? <span style={{ color: "red" }}>*</span> : null}
        </Label>
        <div style={{ display: "flex" }}>
          {prefix && React.createElement(prefix, props)}
          <PhoneInput
            name={name}
            country="in"
            // international
            countryCodeEditable={false}
            //  defaultCountry={defaultCountry}
            //  maxlength={15}

            prefix="+"
            copyNumbersOnly={true}
            international={false}
            placeholder={placeholder}
            value={value}
            inputStyle={{ maxWidth: '260px' }}
            onChange={(val) => {
              console.log(val, "valueee")
              onChange({ target: { value: val } })
              if (onInputChange && typeof onInputChange === "function")
                onInputChange(
                  Object.assign({}, props, {
                    inputValue: { val },
                  })
                )
              // console.log(formattedValue,"zgval4")
              // console.log(formattedValue.dialCode ,"zgval5")
              // console.log(formattedValue.format ,"zgval5")
              // console.log("+" + formattedValue.dialCode ,"zgval6")
              // console.log(data ,"zgval6")
            }}
            disabled={disabled}
          />
        </div>
        {/* 
                <PhoneInput
     value={value}
     country={'in'}
     onChange={(val, data, event, formattedValue) => {
        console.log(val,"zgval1")
        console.log(data,"zgval2")

        console.log(event,"zgval2")

        console.log(formattedValue,"zgval4")

    }}
        
        /> */}
      </FormGroup>
    </React.Fragment>
  )
}

PhoneNumberField.propTypes = {
  t: PropTypes.any,
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  isInvalid: PropTypes.any,
  required: PropTypes.bool,
  style: PropTypes.object,
  disabled: PropTypes.any,
  defaultCountry: PropTypes.any,
  prefix: PropTypes.any,
  onInputChange: PropTypes.func,
}

export default PhoneNumberField
